import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {
    TagBase,
    TagContainer,
    TagWithFrequency
} from "@/models/interfaces/tags/tag-models";

/**
 * Сбрасывает кеш списка тегов после изменения тегов сущности.
 * Импорт ленивый — иначе циклическая зависимость: композабл кеша сам импортирует TagsApi.
 */
function invalidateTagsCache(entityType: number): void {
    void import("@/composables/useTagsCache").then(m => m.revalidateTags(entityType))
}

export class TagsApi {
    // Получение списка тегов для заданной сущности
    static getTagList(type: number): Promise<TagContainer> {
        const http = new CommonHttp()
        return http
            .get(`Tag/list?type=${type}`)
            .then(data => data.data)
    }
    // Создание тега для заданной сущности
    static addTag(model: AddToEntityTagModel): Promise<TagBase[]> {
        const http = new CommonHttp()
        return http
            .post(`Tag/add`, model)
            .then(data => {
                invalidateTagsCache(model.EntityType)
                return data.data
            })
    }

    static AddTag(model: AddToEntityTagModel): Promise<TagWithFrequency[]> {
        const http = new CommonHttp()
        return http
            .post(`Tag/Add`, model)
            .then(data => {
                invalidateTagsCache(model.EntityType)
                return data.data
            })
    }
    // Отсоединение тега от сущности
    static async deleteTag(model: DeleteTagFromEntityModel): Promise<boolean> {
        const http = new CommonHttp()
        const res: any = await http.delete(`Tag/delete`, model)
        if (res?.status !== 204) {
            return false
        }
        invalidateTagsCache(model.EntityType)
        return true
    }
}

export type AddToEntityTagModel = {
    EditingTagId: number,
    Name: string,
    EntityType: number,
    EntityId: number,
}

export type DeleteTagFromEntityModel = {
    TagId: number,
    EntityType: number,
    EntityId: number,
}
